import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {IController} from "../../../controllers/IController";
import {ViewFooterModel} from "../_models/ViewFooterModel";

export const IT_VIEW_FOOTER_CONTROLLER = new InjectionToken<IViewFooterController>('IT_VIEW_FOOTER_CONTROLLER');

export const MK_VIEW_FOOTER = new ModelKey<ViewFooterModel>('MK_VIEW_FOOTER');

export interface IViewFooterController extends IController {

}
